import AddCaseNoteModal from "./AddCaseNoteModal";
import ViewAllCaseNoteModal from "./ViewAllCaseNoteModal";
import { formatDateTime } from "@demandproai/shared";
import AddIcon from '../../../../assets/icons/AddIcon.svg?react';
import { DeleteNoteButton } from "../../../../components";
import useCaseNotes from "../../../../hooks/useCaseNotes";
import XLoaderWithoutStyle from "../../../../components/common/XLoaderWithoutStyle";
import XButton from "../../../../components/common/XButton";
import { noteItemClasses, deleteNoteBtnClasses } from "../../../../components/common/listItemClasses";

const headerRowClasses = "flex justify-between items-center bg-surface-alt px-4 py-1 rounded-t-md";

const noteMetaClasses = "font-bold not-italic text-xs leading-[calc(var(--spacing)*4.5)] tracking-normal text-subtle!";

const noteTextClasses =
    "font-normal text-sm leading-[calc(var(--spacing)*5.25)] tracking-normal text-content " +
    "break-words [overflow-wrap:break-word] [white-space:normal]";

const innerActionRowClasses = "flex justify-between items-center bg-surface-alt";

// The 4px frame is the Stone gutter between note bubbles, so the whole Case Notes
// block reads as one Stone panel; it was still carrying the old mint.
const noteFrameClasses = "border-4! border-surface-alt! p-0 overflow-hidden";

const CaseNotes = ({ caseId, noteData }) => {
    const {
        isNoteDialogOpen,
        setNoteDialogOpen,
        isAllNoteViewOpen,
        setAllNoteViewOpen,
        notes,
        noteFormik,
        deleteNote,
        getNotesLoading,
    } = useCaseNotes(caseId, noteData);

    const showViewMore = notes?.notes?.length > 2;

    return (
        <div className="row my-6!">
            <div className="col-md-12">
                <div className={headerRowClasses}>
                    <strong>Notes</strong>
                    <div className={innerActionRowClasses}>
                        {showViewMore && (
                            <XButton
                                variant="link"
                                onClick={() => setAllNoteViewOpen(true)}
                                className="text-sm!"
                            >
                                View all {notes?.totalNotesCount} notes
                            </XButton>
                        )}
                    </div>
                </div>
                {getNotesLoading && <div className='mt-32 flex justify-center'>
                    <XLoaderWithoutStyle />
                </div>}
                {(!getNotesLoading && notes?.notes) && notes?.notes.slice(0, 2)?.map((note, i) => (
                    <div key={i} className={noteFrameClasses}>
                        <div className={`p-2 bg-surface-alt rounded ${noteItemClasses}`}>
                            <div className="flex justify-between items-center mb-1">
                                <strong className={noteMetaClasses}>{note?.createdBy?.firstName} {note?.createdBy?.lastName}</strong>
                                <strong className={noteMetaClasses}>{formatDateTime(note?.createdAt)}</strong>
                            </div>
                            <p className={noteTextClasses}>
                                {note.text}
                            </p>
                            <div className={deleteNoteBtnClasses}>
                                <DeleteNoteButton onClick={() => deleteNote(note._id)} />
                            </div>
                        </div>
                    </div>
                ))}
                <div className={`${innerActionRowClasses} px-4 py-2 rounded-b-md`}>
                    <XButton
                        variant="link"
                        onClick={() => setNoteDialogOpen(true)}
                        disabled={getNotesLoading}
                        className="text-sm!"
                    >
                        <AddIcon className="mr-1! text-primary" />
                        Add Note
                    </XButton>
                </div>
            </div>
            <AddCaseNoteModal
                isOpen={isNoteDialogOpen}
                setIsOpen={setNoteDialogOpen}
                noteFormik={noteFormik}
                isLoading={getNotesLoading}
            />

            <ViewAllCaseNoteModal
                isOpen={isAllNoteViewOpen}
                setIsOpen={setAllNoteViewOpen}
                noteList={notes?.notes}
                deleteNote={deleteNote}
            />
        </div>

    )
}

export default CaseNotes
